import { createAction } from "@reduxjs/toolkit";

import { useAppDispatch } from "@/store/hooks";

const ActionName = "RESET_ALL";
const resetAllReduxSlicesAction = createAction(ActionName);

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- initialState, across all redux slices, can be truly any data type
const extraReducersFactory = (initialState: Record<string, any>) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const extraReducers = (builder: any) => {
    return builder.addCase(resetAllReduxSlicesAction, () => initialState);
  };
  return extraReducers;
};

const useResetDispatch = () => {
  const dispatch = useAppDispatch();

  const resetAllReduxSlices = () => {
    dispatch(resetAllReduxSlicesAction());
  };

  return {
    resetAllReduxSlices,
  };
};

export { extraReducersFactory, useResetDispatch };
